import axios from 'axios';

const saveOrganizationalHierarchy = (organizationalHierarchy) => {
  return axios.post('/api/organization/save', organizationalHierarchy);
};

const editOrganizationalHierarchy = (updatedHierarchy) => {
  return axios.post('/api/organization/update', updatedHierarchy);
};

const getOrganizationalHierarchy = (config) => {
  return axios.get('/api/organization', config);
};

const createOrganization = (organization) => {
  return axios.post('/api/admin/save', organization);
};

const getOrgLevelsWithCostCenter = (filterByActiveBudget, includeObjectCategories) => {
  return axios.get('/api/organization/orgLevelsWithCostCenter', {
    params: {
      filterByActiveBudget: filterByActiveBudget,
      includeObjectCategories: includeObjectCategories,
    },
  });
};

const getOrganizations = () => {
  return axios.get('/api/admin/organizations');
};

const editOrganization = (data) => {
  return axios.post('/api/admin/edit', data);
};

const copyOrganization = (data) => {
  return axios.post('/api/admin/copy', data);
};

const deleteOrganization = (data) => {
  return axios.delete('/api/admin/delete', { data });
};

const getUsersForOrganization = (orgName, config) => {
  return axios.get('/api/organization/users', {
    params: {
      organizationName: orgName,
    },
    ...config,
  });
};

const checkIfDuplicate = (data, config) => {
  return axios.post('/api/organization/isDuplicate', data, config);
};

const setActiveOrganization = (organization, selectedOrgName) => {
  return axios.post('/api/admin/setActiveOrganization', {
    activeOrganization: organization,
    lastOrganization: selectedOrgName ? selectedOrgName : organization,
  });
};

const getPopulationBoundaries = () => {
  return axios.get('/api/admin/populationBoundaries');
};

export {
  saveOrganizationalHierarchy,
  editOrganizationalHierarchy,
  getOrganizationalHierarchy,
  createOrganization,
  getOrgLevelsWithCostCenter,
  getOrganizations,
  editOrganization,
  copyOrganization,
  deleteOrganization,
  getUsersForOrganization,
  checkIfDuplicate,
  setActiveOrganization,
  getPopulationBoundaries
};
